// Auth Types
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILURE = "UPDATE_PROFILE_FAILURE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_IMAGE = "CHANGE_IMAGE";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";
export const LOST_PASSWORD_CHECK = "LOST_PASSWORD_CHECK";
export const LOST_PASSWORD_UPDATE = "LOST_PASSWORD_UPDATE";
export const OPEN_PASSWORD = "OPEN_PASSWORD";
export const VIEW_DATA_AGENT = "VIEW_DATA_AGENT";
// Helper Action
export const CHANGE_LANGE_KURDISH = "CHANGE_LANGE_KURDISH";
export const CHANGE_LANGE_ARABIC = "CHANGE_LANGE_ARABIC";
export const CHANGE_LANGE_ENGLISH = "CHANGE_LANGE_ENGLISH";

// Salary Acion Type
export const CREATE_FORM_SALARY = "CREATE_FORM_SALARY";
export const GET_LIST_FORM_SALARY = "GET_LIST_FORM_SALARY";
export const VIEW_FORM_SALARY = "VIEW_FORM_SALARY";
export const DELETE_FORM_SALARY = "DELETE_FORM_SALARY";
export const UPDATE_FORM_SALARY = "UPDATE_FORM_SALARY";

// Admin Action
export const CREATE_Branch = "CREATE_Branch";
export const CREATE_ADMIN = "CREATE_ADMIN";
export const GET_LIST_ADMINS = "GET_LIST_ADMINS";
export const GET_BRANCH_OBJECT = "GET_BRANCH_OBJECT";
export const GET_LIST_Branches = "GET_LIST_Branches";
export const VIEW_PROFILE_Branch = "VIEW_PROFILE_Branch";
export const UPDATEING_STATUS = "UPDATEING_STATUS";
export const VIEW_DETAIL_OF_AGGENT_BRANCH = "VIEW_DETAIL_OF_AGGENT_BRANCH";
export const GET_AGENT_BY_NAME = "GET_AGENT_BY_NAME";
export const CREATE_BRANCH_TODO_AGENT = "CREATE_BRANCH_TODO_AGENT";
export const GET_REALESTATE_ADDTODO_TOAGENT = "GET_REALESTATE_ADDTODO_TOAGENT";
// Agent Action
export const CREATE_AGENT = "CREATE_AGENT";
export const UPDATE_NAME_BRANCH = "UPDATE_NAME_BRANCH";
export const GET_LIST_AGENTS = "GET_LIST_AGENTS";
export const VIEW_EDIT_AGENT = "VIEW_EDIT_AGENT";
export const UPDATEING_AGENT_STATUS = "UPDATEING_AGENT_STATUS";
export const GET_LIST_ACTIVE_BRANCHES = "GET_LIST_ACTIVE_BRANCHES";
export const UPDATE_NAME_AGENT = "UPDATE_NAME_AGENT";
export const UPDATEING_Agent_PASSWORD_BY_ADMIN =
  "UPDATEING_Agent_PASSWORD_BY_ADMIN";
export const CREATE_PUNSHED_AGENT = "CREATE_PUNSHED_AGENT";
export const GET_LIST_AGENTS_PUNSHED = "GET_LIST_AGENTS_PUNSHED";
export const VIEW_PUNSHED = "VIEW_PUNSHED";
export const DELETE_PUNSHED = "DELETE_PUNSHED";
export const UPDATE_PUNSHED = "UPDATE_PUNSHED";
// Property Action
export const GET_LIST_PROPERTY_SELL = "GET_LIST_PROPERTY_SELL";
export const GET_LIST_PROPERTY_RENT = "GET_LIST_PROPERTY_RENT";
export const VIEW_DETAIL_RENT = "VIEW_DETAIL_RENT";
export const VIEW_DETAIL_SELL = "VIEW_DETAIL_SELL";
export const UPDATEING_PROPERTY_STATUS = "UPDATEING_PROPERTY_STATUS";
export const DELETE_PROPERTY = "DELETE_PROPERT";
export const GET_LIST_PROPERTY_REQUIRED = "GET_LIST_PROPERTY_REQUIRED";
export const GET_LIST_PROPERTY_REQUIRED_RENT =
  "GET_LIST_PROPERTY_REQUIRED_RENT";
export const GET_DETAIL_OF_CUSTOMER = "GET_DETAIL_OF_CUSTOMER";

export const CUSTOMER_DELETED = "CUSTOMER_DELETED";
export const CISTOMER_UPDATED = "CISTOMER_UPDATED";
export const CUSTOMER_VIEWED = "CUSTOMER_VIEWED";
// Invoice Action
export const GET_SELL_CONTRACTS = "GET_SELL_CONTRACTS";
export const VIEW_CONTRACT_SELL = "VIEW_CONTRACT_SELL";
export const GET_RENT_CONTRACTS = "GET_RENT_CONTRACTS";
export const VIEW_CONTRACT_RENT = "VIEW_CONTRACT_RENT";
export const GET_LIST_OF_TANENTS = "GET_LIST_OF_TANENTS";
export const TAKE_MONEY_VIEW = "TAKE_MONEY_VIEW";
export const GET_EACH_TENANT_LIST = "GET_EACH_TENANT_LIST";
export const VIEW_RECONTRACT = "VIEW_RECONTRACT";
export const TAKE_EACH_MONEY_LIST = "TAKE_EACH_MONEY_LIST";
export const GET_LIST_BILLS = "GET_LIST_BILLS";
export const GET_LIST_PARADAN = "GET_LIST_PARADAN";
export const GET_LIST_ASAYESH = "GET_LIST_ASAYESH";
export const PARADAN_VIEW = "PARADAN_VIEW";
export const SCURETY_VIEW = "SCURETY_VIEW";
export const VIEW_TAKE_MONEY = "VIEW_TAKE_MONEY";
export const GET_ALL_SELL_CONTRACTS = "GET_ALL_SELL_CONTRACTS";
export const GET_ALL_RENT_CONTRACTS = "GET_ALL_RENT_CONTRACTS";
export const GET_ALL_SELL_CONTRACTS_FAILED = "GET_ALL_SELL_CONTRACTS_FAILED";
export const GET_ALL_RENT_CONTRACTS_FAILED = "GET_ALL_RENT_CONTRACTS_FAILED";
export const VIEW_ALL_CONTRACT_RENT = "VIEW_ALL_CONTRACT_RENT";
export const VIEW_ALL_CONTRACT_SELL = "VIEW_ALL_CONTRACT_SELL";
export const DELETE_SELL = "DELETE_SELL";
export const DELETE_RENT = "DELETE_RENT";
export const DELETE_TAKEMONEY = "DELETE_TAKEMONEY";
export const DELETE_PARADAN = "DELETE_PARADAN";
export const GET_PROJECT_BILLS = "GET_PROJECT_BILLS";
export const VIEW_PROJECT_BILLS = "VIEW_PROJECT_BILLS";
export const VIEW_CONTRACT_VELLA = "VIEW_CONTRACT_VELLA";
export const GET_VELLA_CONTRACTS = "GET_VELLA_CONTRACTS";
export const UPDATE_TAKEMONEY = "UPDATE_TAKEMONEY";
export const UPDATE_PARADAN = "UPDATE_PARADAN";
export const UPDATE_SELL_CONTRACT = "UPDATE_SELL_CONTRACT";
export const UPDATE_RENT_CONTRACT = "UPDATE_RENT_CONTRACT";
export const VIEW_TENANT_TAKYMONEY = "VIEW_TENANT_TAKYMONEY";
export const VIEW_TENANT_PARADAN = "VIEW_TENANT_PARADAN";
export const VIEW_TENANT_CONTRACTS = "VIEW_TENANT_CONTRACTS";
export const DELETE_TENANTS = "DELETE_TENANTS";
export const VIEW_WRITORS = "VIEW_WRITORS";
export const GET_WRITERS_LIST = "GET_WRITERS_LIST";
export const WRITER_UPDATE = "WRITER_UPDATE";
export const DELETE_WRITER = "DELETE_WRITER";
export const SCURITY_UPDATE = "SCURITY_UPDATE";
export const SCURETY_DELETE = "SCURETY_DELETE";
export const GET_ALL_SELL_CONTRACTS_DELETE = "GET_ALL_SELL_CONTRACTS_DELETE";
export const GET_ALL_RENT_CONTRACTS_DELETE = "GET_ALL_RENT_CONTRACTS_DELETE";
export const GET_ALL_TAKEMONEY_DELETE = "GET_ALL_TAKEMONEY_DELETE";
export const GET_ALL_PARADAN_DELETE = "GET_ALL_PARADAN_DELETE";
export const GET_ALL_TENANTS_CONTRACTS_DELETE =
  "GET_ALL_TENANTS_CONTRACTS_DELETE";
export const ACTIVATE_TENANT = "ACTIVATE_TENANT";
// Todo Action
export const ADD_TODO_APP = "ADD_TODO_APP";
export const GET_LIST_TODO_APP = "GET_LIST_TODO_APP";
export const UPDATEING_TODO_APP_CHECKBOX = "UPDATEING_TODO_APP_CHECKBOX";
export const DELETE_TODO_APP_CHECKBOX = "DELETE_TODO_APP_CHECKBOX";
export const DELETE_TODO_AGENT_BRANCH = "DELETE_TODO_AGENT_BRANCH";
// Dashboard Action
export const NEWEST_AVILABLE_RENT_PROPERTY = "NEWEST_AVILABLE_RENT_PROPERTY";
export const NEWEST_AVILABLE_SELL_PROPERTY = "NEWEST_AVILABLE_SELL_PROPERTY";
export const NEWEST_TAKEMONEY_CONTRACT = "NEWEST_TAKEMONEY_CONTRACT";
export const NEWEST_CONTRACT_RENT = "NEWEST_CONTRACT_RENT";
export const NEWEST_CONTRACT_SELL = "NEWEST_CONTRACT_SELL";
export const COUNT_PROPERTY = "COUNT_PROPERTY";
export const COUNT_RENT_CONTRACT = "COUNT_RENT_CONTRACT";
export const COUNT_SELL_CONTRACT = "COUNT_SELL_CONTRACT";
export const TOTAL_MONEY_SALES = "TOTAL_MONEY_SALES";
export const SELL_RENT_CONTRACT_CHART = "SELL_RENT_CONTRACT_CHART";
export const SELL_RENT_CONTRACT_CHART_VERTICAL =
  "SELL_RENT_CONTRACT_CHART_VERTICAL";
export const RENT_CONTRACT_CHART_VERTICAL = "RENT_CONTRACT_CHART_VERTICAL";
export const COUNT_REQUIRED = "COUNT_REQUIRED";
// Raport Action
export const SELL_DAILY_RAPORT = "SELL_DAILY_RAPORT";
export const SELL_MONTHLY_RAPORT = "SELL_MONTHLY_RAPORT";
export const SELL_YERALY_RAPORT = "SELL_YERALY_RAPORT";
export const SELL_FROMTO_RAPORT = "SELL_FROMTO_RAPORT";
export const VIEW_SELL_RAPORT = "VIEW_SELL_RAPORT";

export const RENT_DAILY_RAPORT = "RENT_DAILY_RAPORT";
export const RENT_MONTHLY_RAPORT = "RENT_MONTHLY_RAPORT";
export const RENT_YERALY_RAPORT = "RENT_YERALY_RAPORT";
export const RENT_FROMTO_RAPORT = "RENT_FROMTO_RAPORT";
export const VIEW_RENT_RAPORT = "VIEW_RENT_RAPORT";

export const BOX_REPORT_REALESTATE = "BOX_REPORT_REALESTATE";
export const INCOME_REPORT_REALESTATE = "INCOME_REPORT_REALESTATE";
export const INCOME_REPORT_TOTALINCOME = "INCOME_REPORT_TOTALINCOME";

// Account Action
export const LIST_AGENT_SALARY = "LIST_AGENT_SALARY";
export const GET_TOTAL_SALARY_BRANCH = "GET_TOTAL_SALARY_BRANCH";
export const GET_BRANCH_MASRUFAT = "GET_BRANCH_MASRUFAT";
export const GET_TOTAL_BRANCH_MASRUFAT = "GET_TOTAL_BRANCH_MASRUFAT";

//Project Action
export const PROJECT_CREATED = "PROJECT_CREATED";
export const PROJECT_VELLA_CREATED = "PROJECT_VELLA_CREATED";
export const APARTMENT_CREATED = "APARTMENT_CREATED";
export const VELLAS_CREATED = "VELLAS_CREATED";
export const GET_LIST_PROJECTS = "GET_LIST_PROJECTS";
export const GET_PROJECTS = "GET_PROJECTS";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const UPDATE_SHUQA = "UPDATE_SHUQA";
export const UPDATE_VELLA = "UPDATE_VELLA";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const DELETE_TAED = "DELETE_TAED";
export const DELETE_SHUQA = "DELETE_SHUQA";
export const DELETE_VELLA = "DELETE_VELLA";
export const COUNT_SHUQA_BYSTATUS = "COUNT_SHUQA_BYSTATUS";
export const GET_ALL_RENT_PROPERTY = "GET_ALL_RENT_PROPERTY";
export const GET_ALL_SELL_PROPERTY = "GET_ALL_SELL_PROPERTY";
export const VIEW_PROJECTS = "VIEW_PROJECTS";
export const VIEW_VELLA_PROJECTS = "VIEW_VELLA_PROJECTS";
export const VIEW_DETAIL_EACH_SHUQA = "VIEW_DETAIL_EACH_SHUQA";
export const GET_BILLS_PROJECTS = "GET_BILLS_PROJECTS";
export const POST_SELECTS_BILLS = "POST_SELECTS_BILLS";
export const CANCEL_BILL_PROJECT = "CANCEL_BILL_PROJECT";
export const RATIO_EXP_REALESTATE = "RATIO_EXP_REALESTATE";

// Project Raport
export const VIEW_ALL_SELL = "VIEW_ALL_SELL";
export const VIEW_ALL_RENT = "VIEW_ALL_RENT";
// exp Keys
export const EXP_CREATE = "EXP_CREATE";
export const EXP_DELETE = "EXP_DELETE";
export const EXP_LIST = "EXP_LIST";
export const EXP_VIEW = "EXP_VIEW";
export const EXP_UPDATE = "EXP_UPDATE";
export const MASRUFAT_UPDATE = "MASRUFAT_UPDATE";
export const MASRUFAT_VIEW = "MASRUFAT_VIEW";

// PERSENTAGE Acion Type
export const CREATE_FORM_PERSENTAGE = "CREATE_FORM_PERSENTAGE";
export const GET_LIST_FORM_PERSENTAGE = "GET_LIST_FORM_PERSENTAGE";
export const VIEW_FORM_PERSENTAGE = "VIEW_FORM_PERSENTAGE";
export const DELETE_FORM_PERSENTAGE = "DELETE_FORM_PERSENTAGE";
export const UPDATE_FORM_PERSENTAGE = "UPDATE_FORM_PERSENTAGE";

// Agent Raport
export const AGENT_SELL_CONTRACTS = "AGENT_SELL_CONTRACTS";
export const AGENT_RENT_CONTRACTS = "AGENT_RENT_CONTRACTS";
export const AGENT_TAKEMONEY_CONTRACTS = "AGENT_TAKEMONEY_CONTRACTS";
export const AGENT_PARADAN_CONTRACTS = "AGENT_PARADAN_CONTRACTS";
export const AGENT_ADD_PROPERTY = "AGENT_ADD_PROPERTY";
export const AGENT_ADD_REQUIRED_PROPERTY = "AGENT_ADD_REQUIRED_PROPERTY";
export const AGENT_GET_CALCULATIONS = "AGENT_GET_CALCULATIONS";
export const AGENT_VIEW_PARADAN = "AGENT_VIEW_PARADAN";
export const AGENT_VIEW_TAKEMONEY = "AGENT_VIEW_TAKEMONEY";
export const KPI_OF_AGENT = "KPI_OF_AGENT";
export const KPI_OF_AGENT_PROPERTY = "KPI_OF_AGENT_PROPERTY";
export const KPI_OF_AGENT_REQUIRED = "KPI_OF_AGENT_REQUIRED";

// zabuns
export const GET_DETAIL_OF_ZABUN = "GET_DETAIL_OF_ZABUN";
// hr
export const GET_REQUEST_LISTS = "GET_REQUEST_LISTS";
export const VIEW_REQUESTS = "VIEW_REQUESTS";
export const ACTIVE_REQUESTS = "ACTIVE_REQUESTS";
export const HR_FORM_REQUESTS = "HR_FORM_REQUESTS";
export const VIEW_HR_FORM_REQUESTS = "VIEW_HR_FORM_REQUESTS";

export const CREATE_HRS = "CREATE_HRS";
